export default "__VITE_ASSET__rHSXz8e7__"